import { ActionTypes as types } from '../constants/actionTypes';
import { i18n } from '../i18n/translate';
import { WindowHelperWrapper } from '../utils/WindowHelper';

export const displayError = (e, windowOverride) => {
  const statusCode = e.response && e.response.status;
  if (statusCode === 422 || statusCode === 500) {
    return async function (dispatch) {
      let err;
      try {
        err = await e.response.json();
      } catch (_error) {
        // must not be valid JSON, use a default error message
        err = { error: getDefaultErrorMessage(statusCode) };
      }
      if (err.errors) {
        if (err.errors[0].source) {
          // dispatch Homeroom errors
          const homeroomErrors = formatHomeroomFormErrors(err);
          dispatch(displayErrorMessages(homeroomErrors));
        } else {
          dispatch({
            type: types.DISPLAY_ERROR,
            message: err.errors
              .map(error => {
                return error.title;
              })
              .join(', '),
          });
          dispatch({
            type: types.DISPLAY_ERRORS,
            errors: err.errors.map(error => {
              return { error: error.title };
            }),
          });
        }
      } else if (err.error) {
        dispatch({
          type: types.DISPLAY_ERROR,
          message: err.error,
        });
      } else {
        dispatch({
          type: types.DISPLAY_ERRORS,
          errors: err,
        });
      }
    };
  } else if (statusCode === 401) {
    const windowHelper = WindowHelperWrapper(windowOverride);
    windowHelper.reload();
    return displayErrorMessage(i18n.t('Unauthorized'));
  } else {
    const errorMessage = e.message || getDefaultErrorMessage(statusCode);
    return displayErrorMessage(errorMessage);
  }
};

const getDefaultErrorMessage = statusCode => {
  let errorMessage;
  switch (true) {
    case statusCode === 403:
      errorMessage = i18n.t('The request was forbidden');
      break;
    case statusCode === 418:
      errorMessage = i18n.t('The server refuses the attempt to brew coffee with a teapot.');
      break;
    case statusCode >= 400 && statusCode < 500:
      errorMessage = i18n.t('The request was invalid');
      break;
    case statusCode >= 500 && statusCode < 600:
      errorMessage = i18n.t('Internal server error');
      break;
    default:
      errorMessage = i18n.t('Something went wrong');
  }
  return errorMessage;
};

export const displayErrorMessage = message => {
  return dispatch => {
    dispatch(clearMessages());
    dispatch({
      type: types.DISPLAY_ERROR,
      message,
    });
  };
};

export const displayErrorMessages = errors => {
  return dispatch => {
    dispatch(clearMessages());
    dispatch({
      type: types.DISPLAY_ERRORS,
      errors,
    });
  };
};

export const displaySuccessMessage = message => {
  return dispatch => {
    dispatch(clearMessages());
    dispatch({
      type: types.DISPLAY_SUCCESS,
      message,
    });
  };
};

export const formatHomeroomFormErrors = errorMessages => {
  return errorMessages.errors.reduce((acc, curr) => {
    const fieldName = curr.source.pointer.split('/').slice(3, 4)[0];
    if (fieldName) {
      acc[fieldName] = curr.detail;
    }
    return acc;
  }, {});
};

export const capitalizeMessage = message => {
  if (message.substring(0, 3) === 'sso') {
    return 'SSO' + message.slice(4);
  } else {
    return message.charAt(0).toUpperCase() + message.slice(1);
  }
};

export const clearMessages = () => {
  return {
    type: types.CLEAR_MESSAGES,
  };
};
